import Swal from "sweetalert2";

/**
 * Mostra alerta informando que os documentos precisarão ser assinados novamente.
 * @returns {Promise<boolean>} true se usuário confirmou, false se cancelou
 */
export async function confirmarReassinatura() {
  const result = await Swal.fire({
    icon: "warning",
    html: `As alterações nos dados deste responsável invalidam as assinaturas já coletadas das declarações.<br><br>
           Será necessário solicitar novas assinaturas a todos os responsáveis.<br><br>
           <b>Deseja continuar com esta alteração?<b/>`,
    showCancelButton: true,
    confirmButtonText: "Sim, continuar",
    cancelButtonText: "Cancelar",
    reverseButtons: true,
    focusCancel: true,
    allowOutsideClick: false,
  });
  return !!result.isConfirmed;
}
